import { PandaboardApiInstance } from "../../../helpers/api";

export const fetchGetIdLoan = async (idOzoner: string) =>
  PandaboardApiInstance
    .get(`loan/ozoner/${idOzoner}`)
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
